import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";

const GenderSelect = ({ setGender, gender, className }) => {
    const { t, i18n } = useTranslation();
  
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [hoveredItem, setHoveredItem] = useState(null); // Track the hovered item

    console.log("selectedOption",selectedOption)

    const dropdownRef = useRef(null); // Reference to the dropdown element
    const selectRef = useRef(null); // Reference to the select button

    useEffect(() => {
        if (gender === 1) {
            setSelectedOption(t("male"));
        } else if (gender === 2) {
            setSelectedOption(t("female"));
        }
    }, [gender, t]);
    

    // Close the dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target) && 
                dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSelect = (value, genderValue) => {
        setSelectedOption(value);
        setGender(genderValue); // Set the gender value (1 for male, 2 for female)
        setShowDropdown(false); // Close the dropdown

        console.log("genderValue",genderValue)
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    return (
        <div style={styles.customSelect} className={className} ref={selectRef} onClick={toggleDropdown}>
            <div style={styles.selectButton}>
                {selectedOption || t("gender")}
            </div>
            {showDropdown && (
                <ul 
                    style={styles.optionsList} 
                    ref={dropdownRef} 
                    className='options-list'
                >
                    <li 
                        style={{
                            ...styles.optionItem, 
                            backgroundColor: hoveredItem === 'male' ? '#b49345' : 'transparent',
                        }} 
                        onClick={() => handleSelect(t("male"), 1)} // Pass 1 for male
                        onMouseEnter={() => setHoveredItem('male')}
                        onMouseLeave={() => setHoveredItem(null)}
                    >
                        {t("male")}
                    </li>
                    <li 
                        style={{
                            ...styles.optionItem, 
                            backgroundColor: hoveredItem === 'female' ? '#b49345' : 'transparent',
                        }} 
                        onClick={() => handleSelect(t("female"), 2)} // Pass 2 for female
                        onMouseEnter={() => setHoveredItem('female')}
                        onMouseLeave={() => setHoveredItem(null)}
                    >
                        {t("female")}
                    </li>
                </ul>
            )}
        </div>
    );
};

const styles = {
  customSelect: {
    position: 'relative',
    width: '100%',
    border: '2px solid #D1D1D1',
    direction: "rtl",
    // height: "60px",
    borderRadius: "8px",
    display:"flex",
    justfyContent:"center",
    alignItems:"center"
  },
  selectButton: {
    backgroundColor: '#fff',
    // padding: '15px 20px',
    borderRadius: '4px',
    cursor: 'pointer',
    margin: "auto"
  },
  optionsList: {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#fff',
    margin: 0,
    padding: 0,
    listStyle: 'none',
    border: '1px solid #ccc',
    borderRadius: '4px',
    maxHeight: '150px',
    overflowY: 'auto',
    zIndex: 999,
    left: 0,
    right: 0,
    // top: '60px',
  },
  optionItem: {
    padding: '10px',
    cursor: 'pointer',
  },
};

export default GenderSelect;
